// 菜单类型
const RESOURCE_TYPE = {
    // 根目录
    'root': 0, 
    // 目录
    'directory': 1,
    // 菜单
    'menu': 2,
    // 页签
    'tab': 4,
    // 功能点
    'action': 3,
    // 权限分组
    'group': 5,
}

export default RESOURCE_TYPE